import React from "react";
import PropTypes from "prop-types";
import classes from "./articleMin.module.scss";
import { useSelector } from "react-redux";
import Item from "../item/item.js";
import Link from "../../../../UI/link/link.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ArticleMin = () => {
  const rivers = useSelector((state) => state.home.rivers);
  const river = useSelector((state) => state.home.form.rivers.value);
  const link = useSelector((state) => state.home.link);

  return river ? (
    <article className={classes.article}>
      <div className={classes.article__header}>
        <div className={classes.header__img}>
          <img className={classes.img} src={rivers[river].src} alt="river" />
          <div className={classes.linkDetail}>
            <Link
              inner={
                <FontAwesomeIcon icon={link.icon} style={{ fontSize: "3em" }} />
              }
              to={link.to + "?" + river}
            />
          </div>
        </div>
        <div className={classes.header__title}>
          <h2>Річка {rivers[river].name}</h2>
          <p>{rivers[river].preview}</p>
        </div>
      </div>
      <div className={classes.article__pollution}>
        <ul className={classes.pollution__list}>
          {rivers[river].pollutants.map((el, i) => (
            <Item
              name={el.name}
              key={i}
              content={el.content}
              measurer={el.measurer}
              data={el.data}
              danger={el.danger}
              max={el.max}
            />
          ))}
        </ul>
      </div>
    </article>
  ) : null;
};

ArticleMin.propTypes = {
  //products: PropTypes.array
};

export default ArticleMin;
